// extracted by mini-css-extract-plugin
export default {"services-block":"last-services_services-block__nLid4"};